/* PRECIOUS PLUGS — Luxe interactions (reveal, parallax, accordions, sliders) */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ---------- */
  var revealObserver = null;
  function reveal(el) { el.classList.add('is-visible'); }

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-pp-reveal], [data-pp-mask]');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(reveal);
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) {
      if (!el.classList.contains('is-visible')) revealObserver.observe(el);
    });
  }

  /* ---------- Word-by-word statement ---------- */
  function initWords(scope) {
    (scope || document).querySelectorAll('[data-pp-words]').forEach(function (el) {
      if (el.dataset.ppWordsReady) return;
      el.dataset.ppWordsReady = '1';
      if (reduceMotion || !('IntersectionObserver' in window)) return;
      var words = [];
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        var parts = node.textContent.split(/(\s+)/);
        var frag = document.createDocumentFragment();
        parts.forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          var span = document.createElement('span');
          span.className = 'pp-word';
          span.textContent = part;
          frag.appendChild(span);
          words.push(span);
        });
        node.parentNode.replaceChild(frag, node);
      });
      var update = function () {
        var rect = el.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        var start = vh * 0.85;
        var end = vh * 0.35;
        var progress = (start - rect.top) / (start - end + rect.height * 0.5);
        progress = Math.max(0, Math.min(1, progress));
        var lit = Math.round(progress * words.length);
        for (var i = 0; i < words.length; i++) {
          words[i].classList.toggle('is-lit', i < lit);
        }
      };
      el.classList.add('pp-words-ready');
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () { update(); ticking = false; });
          ticking = true;
        }
      }, { passive: true });
      update();
    });
  }

  /* ---------- Parallax ---------- */
  var parallaxEls = [];
  function initParallax(scope) {
    if (reduceMotion) return;
    (scope || document).querySelectorAll('[data-pp-parallax]').forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
  }
  function runParallax() {
    var vh = window.innerHeight || 800;
    parallaxEls.forEach(function (el) {
      if (!el.isConnected) return;
      var rect = el.parentElement.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var speed = parseFloat(el.getAttribute('data-pp-parallax')) || 0.12;
      var offset = (rect.top + rect.height / 2 - vh / 2) * speed * -1;
      el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) scale(1.12)';
    });
  }
  var pTicking = false;
  window.addEventListener('scroll', function () {
    if (!parallaxEls.length || pTicking) return;
    pTicking = true;
    window.requestAnimationFrame(function () { runParallax(); pTicking = false; });
  }, { passive: true });

  /* ---------- Accordions (smooth <details>) ---------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('details.pp-acc').forEach(function (details) {
      if (details.dataset.ppAccReady) return;
      details.dataset.ppAccReady = '1';
      var summary = details.querySelector('summary');
      var content = details.querySelector('.pp-acc__content');
      if (!summary || !content) return;
      summary.addEventListener('click', function (e) {
        if (reduceMotion) return;
        e.preventDefault();
        var group = details.getAttribute('data-pp-acc-group');
        if (!details.open && group) {
          document.querySelectorAll('details.pp-acc[data-pp-acc-group="' + group + '"][open]').forEach(function (other) {
            if (other !== details) closeAcc(other);
          });
        }
        if (details.open) closeAcc(details); else openAcc(details);
      });
    });
  }
  function openAcc(d) {
    var c = d.querySelector('.pp-acc__content');
    d.open = true;
    var h = c.scrollHeight;
    c.style.height = '0px';
    c.style.opacity = '0';
    requestAnimationFrame(function () {
      c.style.transition = 'height .55s cubic-bezier(.22,1,.36,1), opacity .55s ease';
      c.style.height = h + 'px';
      c.style.opacity = '1';
    });
    c.addEventListener('transitionend', function te(ev) {
      if (ev.propertyName !== 'height') return;
      c.style.height = '';
      c.style.transition = '';
      c.removeEventListener('transitionend', te);
    });
  }
  function closeAcc(d) {
    var c = d.querySelector('.pp-acc__content');
    c.style.height = c.scrollHeight + 'px';
    requestAnimationFrame(function () {
      c.style.transition = 'height .45s cubic-bezier(.22,1,.36,1), opacity .35s ease';
      c.style.height = '0px';
      c.style.opacity = '0';
    });
    c.addEventListener('transitionend', function te(ev) {
      if (ev.propertyName !== 'height') return;
      d.open = false;
      c.style.height = '';
      c.style.opacity = '';
      c.style.transition = '';
      c.removeEventListener('transitionend', te);
    });
  }

  /* ---------- Generic scroll-snap slider with dots / counter ---------- */
  function initSliders(scope) {
    (scope || document).querySelectorAll('[data-pp-slider]').forEach(function (wrap) {
      if (wrap.dataset.ppSliderReady) return;
      wrap.dataset.ppSliderReady = '1';
      var track = wrap.querySelector('[data-pp-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var dots = wrap.querySelectorAll('[data-pp-dot]');
      var current = wrap.querySelector('[data-pp-current]');
      var prev = wrap.querySelector('[data-pp-prev]');
      var next = wrap.querySelector('[data-pp-next]');
      var index = 0;
      var setActive = function (i) {
        index = i;
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
        if (current) current.textContent = i + 1;
      };
      var goTo = function (i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        var slide = slides[i];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      track.addEventListener('scroll', function () {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / (slides[0] ? slides[0].getBoundingClientRect().width || w : w));
        if (i !== index) setActive(Math.max(0, Math.min(slides.length - 1, i)));
      }, { passive: true });
      dots.forEach(function (d, di) { d.addEventListener('click', function () { goTo(di); }); });
      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });
      wrap.ppGoTo = goTo;
      setActive(0);
    });
  }

  function initAll(scope) {
    initReveal(scope);
    initWords(scope);
    initParallax(scope);
    initAccordions(scope);
    initSliders(scope);
    runParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('details.pp-acc')) el.open = true;
    var slider = el && el.closest ? el.closest('[data-pp-slider]') : null;
    if (slider && slider.ppGoTo) {
      var track = slider.querySelector('[data-pp-track]');
      var idx = Array.prototype.indexOf.call(track.children, el.closest('[data-pp-track] > *'));
      if (idx > -1) slider.ppGoTo(idx);
    }
  });

  window.PPLuxe = { init: initAll };
  root.classList.add('pp-ready');
})();
